import { Box, HStack, Icon, Link, Text } from '@chakra-ui/react';
import { CapybaraToken } from '@cronos-app/icons';
import { currentWallet } from '@cronos-app/wallet';
import { Amount } from '@ui/components/Atoms/Amount';
import WhiteButton from '@ui/components/Atoms/WhiteButton';
import { VvsSwapUrl, VvsToken } from '@ui/config/urls';
import { useBaraBalance } from '@ui/hooks/contracts/useBaraBalance';
import { useTranslations } from 'next-intl';

const MyBaraTokenSection = () => {
  const { data } = useBaraBalance();
  const t = useTranslations();
  const isConnected = currentWallet.useIsConnected();

  if (!isConnected) {
    return null;
  }

  return (
    <HStack
      background="linear-gradient(102deg, #9226FF 5.03%, #38CFFF 102.71%)"
      gap="10px"
      p={3}
      rounded="xl"
    >
      <Icon boxSize={10}>
        <CapybaraToken />
      </Icon>
      <Box>
        <Text color="white" fontFamily="luckiestGuy" mt={1} mb={-1}>
          $BARA in Your Wallet
        </Text>
        <Amount color="white" value={data?.totalNumber} suffix=" BARA" />
      </Box>
      <Link
        href={VvsSwapUrl(VvsToken.CRO, VvsToken.BARA)}
        target="_blank"
        ml="auto"
      >
        <WhiteButton rounded="full" size="sm">
          <Text fontSize={18} pt={1} px={1}>
            {t('common.Buy')}
          </Text>
        </WhiteButton>
      </Link>
    </HStack>
  );
};

export default MyBaraTokenSection;
